//#region types
import { BaseFormFieldProps, WintVerticalFormFieldProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import FormField from "./formField";
//#endregion

export type VerticalFormFieldProps<T extends BaseFormFieldProps> = WintVerticalFormFieldProps & T;

function VerticalFormField<T extends BaseFormFieldProps>(props: VerticalFormFieldProps<T>) {
  const { showMainLabel } = props;

  return <FormField<T> {...props} direction="vertical" hideMainLabel={!showMainLabel} />;
}

export default VerticalFormField;
